module.exports = __webpack_public_path__ + "img/missingWord.21daf604.png";